export const ORDER_BY_NEWEST = 'orderByNewest';
export const ORDER_BY_HIGHEST = 'orderByHighest';
export const ORDER_BY_LOWEST = 'orderByLowest';
